module.exports = __webpack_public_path__ + "static/media/crown_touch3.390589e2.jpg";